import { is } from '@common/is/is'

import DOM from '@common/DOM/DOM'

import SVGIcon from '../SVGIcon/SVGIcon'

import styles from './Notification.css'

interface IProps {
  readonly type?: 'danger' | 'error' | 'success'
  readonly msg?: string
  readonly children?: unknown
}

/**
 * Notification komponens factory-ja, általában ajax hibaüzenetek megjelenítésére.
 * @param props - JSX props {@link IProps}.
 */
export default function Notification (props: IProps): HTMLElement {
  let parent = document.querySelector(`.${ styles.notificationContainer }`)

  if (!is.instanceOf(parent, HTMLElement)) {
    parent = <div className={ styles.notificationContainer } /> as HTMLElement

    document.body.appendChild(parent)
  }

  const notifType = props.type ?? 'success'

  let notif: HTMLElement

  /** Notification kidobása a DOM-ból. */
  function onceClick (): void {
    DOM.remove(notif)
  }

  notif = (
    <div className={ styles.notification } data-type={ notifType } onceClick={ onceClick }>
      <div className={ styles.icon }>
        <SVGIcon
          size="32"
          type={ notifType === 'danger' || notifType === 'error' ? 'danger' : 'info' }
          viewBox="0 0 64 64"
        />
      </div>

      <div className={ styles.text }>
        { props.msg
          ? (
            <div
              className={ styles.content }
              dangerouslySetInnerHTML={ { __html: props.msg ?? '?' } }
            />
          )
          : props.children }
      </div>
    </div>
  )

  parent.appendChild(notif)

  return notif
}
